<template>
  <div>
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <div>
      <v-col align="center">
        <v-text-field class="centered-input" v-model="search" append-icon="search" label="Search Module" single-line
          hide-details style="width: 50%"></v-text-field>
      </v-col>
      <v-row dense>
        <v-col sm="3" md="3" v-for="linkname in filteredSortSearchList" :key="linkname.name" :cols="linkname.flex">
          <router-link :to="{ name: linkname.name }" style="text-decoration: none">
            <v-card :elevation="4" class="card" fill-height style="margin: 8px; height: 90%">
              <br />
              <v-img height="150px">
                <center>
                  <v-avatar color="#2c3e50" class="avatar-icon" size="60">
                    <span>
                      <v-icon size="50" class="link-icon">{{
                        linkname.icon
                        }}</v-icon>
                    </span>
                  </v-avatar>
                  <v-col cols="12" sm="12" md="12">
                    <center>
                      <strong><span class="linkname">{{
                          linkname.textval
                          }}</span></strong>
                    </center>
                  </v-col>
                  <!-- <v-card-title v-text="linkname.textval" class="card-title"></v-card-title> -->
                </center>
              </v-img>
              <v-card-actions>
                <v-avatar v-if="linkname.size == 0" color="red darken-1" size="30">
                  <span class="white--text" :title="'#' + linkname.size + ' Field Added'">{{ linkname.size }}</span>
                </v-avatar>
                <v-avatar v-else color="#2c3e50" size="30">
                  <span class="white--text" :title="'#' + linkname.size + ' Field Added'">{{ linkname.size }}</span>
                </v-avatar>
                <v-spacer></v-spacer>
                <router-link :to="{ name: linkname.name }" class="white--text" style="text-decoration: none">
                  <v-btn icon size="30">
                    <v-icon size="30" color="#2c3e50"
                      :title="'Click here to Add ' + linkname.textval">mdi-plus-circle</v-icon>
                  </v-btn>
                </router-link>
              </v-card-actions>
            </v-card>
          </router-link>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import axios from "axios";

import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed

import "@/assets/css/color.css";
export default {
  components: {
    Breadcrumbs,
  },
  data: () => ({
    snackbar_msg: "",
    color: "",
    snackbar: false,
    // extraBreadcrumbItems: [


    // ],
    // breadcrumbClass: "breadcrumb-style1",
    overlay: false,
    routerLinkList: [],
    search:""
    ///////////////////////////////////////////////
  }),
  mounted() {
    axios
      .get("InwardOutward/InwardOutwardMaster")
      .then((res) => {
        //window.console.log("res"+res.data)
        if (res.data.msg == "200") {
          this.overlay = false;
          this.data = res.data;
          this.routerLinkList = res.data.routerLinkList;
          //console.log(this.data)
        } else {
          this.showSnackbar("red", res.data.snackbar);
          sessionStorage.setItem("error-trace", res.data.error_trace);
          this.overlay = false;
        }
      })
      .catch((error) => {
        window.console.log(error);
        this.overlay = false;
      })
      .finally(() => {
        this.overlay = false;
      });
    // const formdata = {};
    // axios
    //   .post("", formdata)
    //   .then((res) => {
    //     if (res.data.flag == "YES") {
    //       this.overlay = false;
    //     } else {
    //       this.showSnackbar("red", res.data.snackbar);
    //       sessionStorage.setItem("error-trace", res.data.error_trace);
    //       this.overlay = false;
    //     }
    //     this.overlay = false;
    //   })
    //   .catch((error) => {
    //     this.onerror(error);

    //     this.overlay = false;
    //   })
    //   .finally(() => {
    //     this.overlay = false;
    //     // this.selected_date=""
    //   });
  },
  methods: {
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    onerror(error) {
      let msg = "";
      if (error.response) {
        msg = "Something went wrong.";
      } else if (error.request) {
        msg = "Please try again.";
      } else {
        msg = "Un-expected error.";
      }
      this.showSnackbar("error", msg);
    },
  },
  computed: {
    filteredSortSearchList() {
      function compare(a, b) {
        if (a.name < b.name) return -1;
        if (a.name > b.name) return 1;
        return 0;
        //return this.routerLinkList.sort(compare);
      }

      // return _.orderBy(arrays, 'name', 'asc'); this is for sort by
      if (!this.search) return this.routerLinkList.sort(compare);

      return this.routerLinkList.filter((tbdata) => {
        return (
          tbdata.name.toLowerCase().indexOf(this.search.toLowerCase()) >= 0
        );
      });
    },
  },
};
</script>

<style scoped>
.card {
  border: #2c3e50 !important;
}
.card:hover {
  background: #bdc3c7; /* fallback for old browsers */
  background: -webkit-linear-gradient(
    to right,
    #515e6b,
    #bdc3c7
  ); /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(
    to right,
    #515e6b,
    #bdc3c7
  ); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  color: white !important;
  font-weight: bold !important;
  text-align: center;
  box-shadow: 20px 20px 20px grey !important;
  -webkit-transition: box-shadow 0.3s ease-in !important;
}
.link-icon {
  color: white;
}
.add-plus-icon:hover {
  color: white;
}
linkname {
  color: #2c5364 !important;
}
</style>